var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoney(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "rupee_a2itxe7w3y5m 2",
    clipPath: "url(#clip0_5302_36037)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.5865 8.04941H11.8652C11.767 7.10071 11.2553 6.21976 10.5065 5.67765H13.5865C13.7728 5.67765 13.9253 5.52518 13.9253 5.33882C13.9253 5.15247 13.7728 5 13.5865 5H6.41695C6.2306 5 6.07812 5.15247 6.07812 5.33882C6.07812 5.52518 6.2306 5.67765 6.41695 5.67765H8.47022C9.86617 5.67765 11.0182 6.728 11.1842 8.04941H6.41695C6.2306 8.04941 6.07812 8.20188 6.07812 8.38824C6.07812 8.57459 6.2306 8.72706 6.41695 8.72706H11.1842C11.0148 10.0993 9.84923 11.1293 8.47022 11.1327H6.42034C6.2306 11.1361 6.07812 11.292 6.08151 11.4817C6.08151 11.5732 6.12217 11.6613 6.18655 11.7256L11.3129 16.5742C11.4485 16.703 11.6619 16.6962 11.7907 16.5607C11.9194 16.4217 11.9127 16.2083 11.7771 16.0761L7.2674 11.8104H8.46683C10.2355 11.8104 11.6958 10.4551 11.8652 8.72706H13.5865C13.7728 8.72706 13.9253 8.57459 13.9253 8.38824C13.9253 8.20188 13.7728 8.04941 13.5865 8.04941Z",
    fill: "#ffffff",
    stroke: "#ffffff",
    strokeWidth: 0.4
  }))), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 295",
    cx: 10,
    cy: 10,
    r: 9.4,
    stroke: "#ffffff",
    strokeWidth: 1.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5302_36037"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoney);
export default __webpack_public_path__ + "static/media/money.0cefe1d797cb4e2b6d36a0099d634b2e.svg";
export { ForwardRef as ReactComponent };